/* B2B PLP behaviors: card qty stepper + AJAX add (opens drawer), quick view,
   add-to-list (shares 'saved-for-later' with the cart), grid/list view toggle
   (persisted), items-per-page. Vanilla JS, delegated listeners, no frameworks. */
/* two sections may emit this same script tag; execute once */
if (!window.__plpB2B) {
  window.__plpB2B = true;

(function () {
  'use strict';

  var VIEW_KEY = 'plp-view';

  function refreshCartUi() {
    /* cart-b2b.js's Section Rendering refresh + drawer open */
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    if (window.publish) window.publish('cart-update', { source: 'plp-card' });
  }

  /* ---- qty stepper + add ---- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (minus || plus) {
      var box = (minus || plus).closest('[data-card-qty]');
      var input = box.querySelector('input');
      var value = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, value + (plus ? 1 : -1));
      return;
    }

    var add = e.target.closest('[data-card-add]');
    if (add && add.hasAttribute('data-variant-id')) {
      e.preventDefault();
      if (add.hasAttribute('data-busy')) return;
      /* the qty stepper lives in the card OR the quick-view panel */
      var card = add.closest('[data-b2b-card], [data-qv-content]');
      var qtyInput = card && card.querySelector('[data-card-qty] input');
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      add.setAttribute('data-busy', '');
      var label = add.textContent;
      add.textContent = ((window.b2bStrings || {}).adding || '…');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(add.getAttribute('data-variant-id'), 10), quantity: qty })
      })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(function (item) {
          add.textContent = ((window.b2bStrings || {}).added || 'Added');
          /* remember handles in the cart; the checkout click promotes them to
             'b2b-ordered', which drives the Previously-purchased badge */
          try {
            /* only accumulate history when the badge feature is enabled */
            if (item && item.handle && window.b2bFlags && window.b2bFlags.prevPurchased) {
              var ch = JSON.parse(localStorage.getItem('b2b-cart-handles') || '[]');
              if (ch.indexOf(item.handle) === -1) ch.push(item.handle);
              localStorage.setItem('b2b-cart-handles', JSON.stringify(ch.slice(-60)));
            }
          } catch (err) {}
          refreshCartUi();
          setTimeout(function () {
            add.textContent = label;
            add.removeAttribute('data-busy');
          }, 1200);
        })
        .catch(function () {
          add.textContent = ((window.b2bStrings || {}).tryAgain || 'Try again');
          setTimeout(function () {
            add.textContent = label;
            add.removeAttribute('data-busy');
          }, 1500);
        });
      return;
    }

    var quickView = e.target.closest('[data-quick-view]');
    if (quickView) {
      e.preventDefault();
      /* no modal library: quick view = navigate; kept as a hook for later */
      window.location.href = quickView.getAttribute('data-product-url');
      return;
    }

    var addList = e.target.closest('[data-add-to-list]');
    if (addList) {
      e.preventDefault();
      var saved = [];
      try { saved = JSON.parse(localStorage.getItem('saved-for-later') || '[]'); } catch (err) {}
      var id = addList.getAttribute('data-variant-id');
      if (!saved.some(function (s) { return String(s.variantId) === id; })) {
        saved.push({
          variantId: id,
          title: addList.getAttribute('data-item-title'),
          price: addList.getAttribute('data-item-price'),
          url: addList.getAttribute('data-item-url')
        });
        try { localStorage.setItem('saved-for-later', JSON.stringify(saved)); } catch (err) {}
      }
      var original = addList.textContent;
      addList.textContent = ((window.b2bStrings || {}).saved || 'Saved ✓');
      setTimeout(function () { addList.textContent = original; }, 1500);
      return;
    }

    /* ---- view toggle ---- */
    var viewBtn = e.target.closest('[data-view-toggle]');
    if (viewBtn) {
      var view = viewBtn.getAttribute('data-view-toggle');
      applyView(view);
      try { localStorage.setItem(VIEW_KEY, view); } catch (err) {}
      return;
    }

    /* ---- density toggle ---- */
    var densBtn = e.target.closest('[data-density-toggle]');
    if (densBtn) {
      var dens = densBtn.getAttribute('data-density-toggle');
      applyDensity(dens);
      try { localStorage.setItem('plp-density', dens); } catch (err) {}
    }
  });

  function applyDensity(dens) {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    grid.classList.toggle('b2b-grid--dense', dens === 'dense');
    document.querySelectorAll('[data-density-toggle]').forEach(function (b) {
      var active = b.getAttribute('data-density-toggle') === dens;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
  try {
    if (localStorage.getItem('plp-density') === 'dense') applyDensity('dense');
  } catch (e) {}

  function applyView(view) {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    grid.classList.toggle('b2b-grid--list', view === 'list');
    document.querySelectorAll('[data-view-toggle]').forEach(function (b) {
      var active = b.getAttribute('data-view-toggle') === view;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    grid.querySelectorAll('.b2b-card').forEach(function (c) {
      c.classList.toggle('b2b-card--list', view === 'list');
      c.classList.toggle('b2b-card--grid', view !== 'list');
    });
  }

  /* ---- collection intro "Read more" (button only when clamped) ---- */
  document.querySelectorAll('[data-collection-intro]').forEach(function (intro) {
    var text = intro.querySelector('.collection-intro__text');
    var more = intro.querySelector('[data-intro-more]');
    if (!text || !more) return;
    if (text.scrollHeight > text.clientHeight + 2) {
      more.hidden = false;
      more.addEventListener('click', function () {
        intro.classList.add('is-expanded');
        more.hidden = true;
      });
    }
  });

  /* restore persisted view (grid is default markup) */
  try {
    if (localStorage.getItem(VIEW_KEY) === 'list') applyView('list');
  } catch (e) {}

  /* re-apply after facet AJAX re-renders swap the grid */
  new MutationObserver(function () {
    try {
      if (localStorage.getItem(VIEW_KEY) === 'list') applyView('list');
    } catch (e) {}
  }).observe(document.getElementById('ProductGridContainer') || document.body, { childList: true, subtree: false });

  /* ---- items per page ---- */
  /* server-side via alternate templates: the toolbar select navigates to
     ?view=24 / (default) / ?view=96 so Liquid paginates correctly */
  document.addEventListener('change', function (e) {
    var per = e.target.closest('[data-per-page]');
    if (per) {
      var url = new URL(window.location.href);
      if (per.value === '48') url.searchParams.delete('view');
      else url.searchParams.set('view', per.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });
})();

/* Shared: keep Tab inside an open aria-modal dialog */
if (!window.trapModalFocus) {
  window.trapModalFocus = function (modal) {
    if (modal._trapBound) return;
    modal._trapBound = true;
    /* visible = rendered boxes and no hidden ancestor; offsetParent is null for
       position:fixed elements (the mobile close button) and would drop them */
    var isVisible = function (el) {
      if (el.hidden || el.closest('[hidden]')) return false;
      if (typeof el.checkVisibility === 'function') return el.checkVisibility();
      return el.getClientRects().length > 0;
    };
    var getFocusables = function () {
      return Array.from(modal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(isVisible);
    };
    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || modal.hidden) return;
      var focusables = getFocusables();
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    /* escape hatch: focus that still leaves the dialog comes straight back */
    modal.addEventListener('focusout', function (e) {
      if (modal.hidden || !e.relatedTarget || modal.contains(e.relatedTarget)) return;
      var focusables = getFocusables();
      if (focusables.length) focusables[0].focus();
    });
  };
}

/* ================= Elite PLP extras ================= */
(function () {
  'use strict';

  /* ---------- custom dropdowns (sort / per-page) ---------- */
  function closeAllSelects(except) {
    document.querySelectorAll('[data-b2b-select]').forEach(function (sel) {
      if (sel === except) return;
      var menu = sel.querySelector('.b2b-select__menu');
      var btn = sel.querySelector('.b2b-select__button');
      if (menu) menu.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.b2b-select__button');
    if (btn) {
      var sel = btn.closest('[data-b2b-select]');
      var menu = sel.querySelector('.b2b-select__menu');
      closeAllSelects(sel);
      menu.hidden = !menu.hidden;
      btn.setAttribute('aria-expanded', menu.hidden ? 'false' : 'true');
      return;
    }
    var opt = e.target.closest('.b2b-select__option');
    if (opt) {
      var wrap = opt.closest('[data-b2b-select]');
      var value = opt.getAttribute('data-value');
      var label = wrap.querySelector('[data-select-label]');
      if (label) label.textContent = opt.textContent.trim();
      wrap.querySelectorAll('.b2b-select__option').forEach(function (o) {
        if (o === opt) o.setAttribute('aria-current', 'true');
        else o.removeAttribute('aria-current');
      });
      wrap.querySelector('.b2b-select__menu').hidden = true;
      wrap.querySelector('.b2b-select__button').setAttribute('aria-expanded', 'false');

      if (value === 'ships-fastest') {
        var grid2 = document.getElementById('product-grid');
        if (grid2) {
          Array.from(grid2.children)
            .sort(function (a, b) {
              var la = parseInt((a.querySelector('[data-b2b-card]') || {}).getAttribute ? a.querySelector('[data-b2b-card]').getAttribute('data-lead') : 99, 10) || 99;
              var lb = parseInt((b.querySelector('[data-b2b-card]') || {}).getAttribute ? b.querySelector('[data-b2b-card]').getAttribute('data-lead') : 99, 10) || 99;
              return la - lb;
            })
            .forEach(function (li) { grid2.appendChild(li); });
        }
        return;
      }
      if (value === 'brand-ascending') {
        /* no native vendor sort: client-side reorder of the loaded page */
        var grid = document.getElementById('product-grid');
        if (grid) {
          Array.from(grid.children)
            .sort(function (a, b) {
              var va = (a.querySelector('.b2b-card__brand') || {}).textContent || '';
              var vb = (b.querySelector('.b2b-card__brand') || {}).textContent || '';
              return va.localeCompare(vb);
            })
            .forEach(function (li) { grid.appendChild(li); });
        }
        return;
      }
      var native = document.querySelector(wrap.getAttribute('data-native'));
      if (native) {
        native.value = value;
        /* facets.js listens for bubbled input on the form; per-page listens for change */
        native.dispatchEvent(new Event('input', { bubbles: true }));
        native.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
    if (!e.target.closest('[data-b2b-select]')) closeAllSelects(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllSelects(null);
  });

  /* ---------- compare + bulk select (max 4) ---------- */
  var MAX_COMPARE = 4;
  var bar = document.querySelector('[data-select-bar]');

  function selectedChecks() {
    return Array.from(document.querySelectorAll('[data-compare-check]:checked'));
  }

  function refreshBar() {
    var n = selectedChecks().length;
    if (bar) {
      bar.hidden = n === 0;
      var count = bar.querySelector('[data-select-count]');
      if (count) {
        var template = count.getAttribute('data-count-label') || '[n] selected';
        count.textContent = template.replace('[n]', n);
      }
      var cmp = bar.querySelector('[data-compare-open]');
      if (cmp) cmp.disabled = n < 2;
    }
    var counter = document.querySelector('[data-compare-counter]');
    if (counter) {
      counter.hidden = n === 0;
      var cc = counter.querySelector('[data-compare-count]');
      if (cc) cc.textContent = n;
    }
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-compare-check]')) return;
    if (e.target.checked && selectedChecks().length > MAX_COMPARE) {
      e.target.checked = false;
      return;
    }
    refreshBar();
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-select-clear]')) {
      selectedChecks().forEach(function (c) { c.checked = false; });
      refreshBar();
      return;
    }

    if (e.target.closest('[data-bulk-add-selected]')) {
      var btn = e.target.closest('[data-bulk-add-selected]');
      if (btn.hasAttribute('data-busy')) return;
      var items = selectedChecks().map(function (c) {
        return { id: parseInt(c.getAttribute('data-variant-id'), 10), quantity: 1 };
      });
      if (!items.length) return;
      btn.setAttribute('data-busy', '');
      var old = btn.textContent;
      btn.textContent = ((window.b2bStrings || {}).adding || 'Adding…');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          btn.textContent = ((window.b2bStrings || {}).added || 'Added');
          setTimeout(function () { btn.textContent = old; btn.removeAttribute('data-busy'); }, 1500);
        })
        .catch(function () {
          btn.textContent = ((window.b2bStrings || {}).tryAgain || 'Try again');
          setTimeout(function () { btn.textContent = old; btn.removeAttribute('data-busy'); }, 1500);
        });
      return;
    }

    if (e.target.closest('[data-compare-open]')) {
      var modal = document.querySelector('[data-compare-modal]');
      var host = modal && modal.querySelector('[data-compare-table]');
      if (!modal || !host) return;
      /* harvest comparison data straight from the selected cards' DOM */
      var cards = selectedChecks().map(function (c) { return c.closest('[data-b2b-card]'); });
      var FIXED = ['brand', 'mpn', 'model', 'price', 'availability'];
      var specNames = [];
      var cardData = cards.map(function (card) {
        var specs = {};
        card.querySelectorAll('.b2b-card__spec-highlights li').forEach(function (li) {
          var name = (li.querySelector('span') || {}).textContent || '';
          name = name.replace(/:$/, '');
          specs[name] = li.textContent.replace(name + ':', '').trim();
          if (specNames.indexOf(name) === -1 && FIXED.indexOf(name.toLowerCase()) === -1) specNames.push(name);
        });
        return {
          title: (card.querySelector('.b2b-card__title-link') || {}).textContent || '',
          url: (card.querySelector('.b2b-card__title-link') || {}).href || '#',
          brand: ((card.querySelector('.b2b-card__brand') || {}).textContent || '').trim(),
          mpn: ((card.querySelector('.b2b-card__mpn') || {}).textContent || '').replace('MPN:', '').trim(),
          price: ((card.querySelector('.b2b-card__price') || {}).textContent || '').trim(),
          ship: ((card.querySelector('.b2b-card__ship') || {}).textContent || '').trim(),
          specs: specs
        };
      });
      var esc = function (t) {
        return String(t).replace(/[&<>"']/g, function (ch) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
        });
      };
      var html = '<table class="plp-compare-table"><thead><tr><th></th>';
      cardData.forEach(function (d) { html += '<th><a class="link" href="' + esc(d.url) + '">' + esc(d.title.trim()) + '</a></th>'; });
      html += '</tr></thead><tbody>';
      [['Brand', 'brand'], ['MPN', 'mpn'], ['Price', 'price'], ['Availability', 'ship']].forEach(function (row) {
        html += '<tr><th scope="row">' + row[0] + '</th>';
        cardData.forEach(function (d) { html += '<td>' + esc(d[row[1]] || '—') + '</td>'; });
        html += '</tr>';
      });
      specNames.forEach(function (name) {
        html += '<tr><th scope="row">' + esc(name) + '</th>';
        cardData.forEach(function (d) { html += '<td>' + esc(d.specs[name] || '—') + '</td>'; });
        html += '</tr>';
      });
      html += '</tbody></table>';
      host.innerHTML = html;
      modal.hidden = false;
      var closeBtn = modal.querySelector('[data-compare-close]');
      modal._returnFocus = e.target.closest('[data-compare-open]');
      if (closeBtn) closeBtn.focus();
      if (window.trapModalFocus) window.trapModalFocus(modal);
      return;
    }

    var modalEl = document.querySelector('[data-compare-modal]');
    if (modalEl && !modalEl.hidden) {
      if (e.target.closest('[data-compare-close]') || e.target === modalEl) closeCompare(modalEl);
    }
  });

  function closeCompare(modal) {
    modal.hidden = true;
    if (modal._returnFocus) { modal._returnFocus.focus(); modal._returnFocus = null; }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var modal = document.querySelector('[data-compare-modal]');
    if (modal && !modal.hidden) { e.stopPropagation(); closeCompare(modal); }
  }, true);
  refreshBar();

  /* ---------- quick filter chips (page-scope, like Brand A-Z) ---------- */
  var chipState = { instock: false, fast: false };
  var chipCountText = null; /* last string the chip code wrote into the count - anything else is a fresh real count */
  function cardMatches(card, key) {
    if (key === 'instock') return card.getAttribute('data-available') === 'true';
    return (parseInt(card.getAttribute('data-lead'), 10) || 99) <= 1;
  }
  function applyChips() {
    var items = document.querySelectorAll('#product-grid > li');
    var visible = 0;
    items.forEach(function (li) {
      var card = li.querySelector('[data-b2b-card]');
      if (!card) return;
      var hide = false;
      if (chipState.instock && !cardMatches(card, 'instock')) hide = true;
      if (chipState.fast && !cardMatches(card, 'fast')) hide = true;
      li.style.display = hide ? 'none' : '';
      if (!hide) visible++;
    });
    /* every card hidden by a chip: say so instead of showing a blank grid */
    var empty = document.querySelector('[data-chip-empty]');
    if (empty) empty.hidden = !(items.length && visible === 0 && (chipState.instock || chipState.fast));
    /* facets.js rewrites #ProductCountDesktop on every facet change, so the snapshot of the
       real count is taken only while a chip is active and dropped as soon as chips clear */
    var count = document.getElementById('ProductCountDesktop');
    var active = chipState.instock || chipState.fast;
    if (count && items.length) {
      if (active) {
        /* facets.js may have written a new real count since the snapshot: re-snapshot it */
        if (!count.hasAttribute('data-full-text') || (chipCountText !== null && count.textContent !== chipCountText)) {
          count.setAttribute('data-full-text', count.textContent);
        }
        var tpl = visible === 1 ? count.getAttribute('data-chip-count-one') : count.getAttribute('data-chip-count-text');
        if (tpl) { chipCountText = tpl.replace('{count}', visible); count.textContent = chipCountText; }
      } else if (count.hasAttribute('data-full-text')) {
        count.textContent = count.getAttribute('data-full-text');
        count.removeAttribute('data-full-text');
        chipCountText = null;
      }
    }
  }
  /* a chip that would not change anything on this page is disabled (every card already
     qualifies, or none can) - so a buyer never taps "Ships in 1 day" into a dead grid */
  function primeChips() {
    var cards = Array.from(document.querySelectorAll('#product-grid > li [data-b2b-card]'));
    if (!cards.length) return;
    ['instock', 'fast'].forEach(function (key) {
      var matching = cards.filter(function (c) { return cardMatches(c, key); }).length;
      var useless = matching === 0 || matching === cards.length;
      document.querySelectorAll('[data-quick-chip="' + key + '"]').forEach(function (c) {
        c.disabled = useless;
        c.classList.toggle('plp-chip--inert', useless);
        if (useless) c.setAttribute('title', c.getAttribute('data-inert-title') || '');
        else c.removeAttribute('title');
      });
    });
  }
  primeChips();
  /* the grid is re-rendered by facets.js (filter/sort) and extended by Load more: re-evaluate
     inert state and re-apply active chips to the new cards */
  var gridHost = document.getElementById('ProductGridContainer');
  if (gridHost && 'MutationObserver' in window) {
    new MutationObserver(function () { primeChips(); applyChips(); }).observe(gridHost, { childList: true, subtree: true });
  }
  document.addEventListener('click', function (e) {
    var reset = e.target.closest('[data-chip-reset]');
    if (!reset) return;
    chipState.instock = chipState.fast = false;
    document.querySelectorAll('[data-quick-chip]').forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-pressed', 'false'); });
    applyChips();
  });
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-quick-chip]');
    if (!chip) return;
    var key = chip.getAttribute('data-quick-chip');
    chipState[key] = !chipState[key];
    /* the same toggle exists in the toolbar and at the top of the filter rail */
    document.querySelectorAll('[data-quick-chip="' + key + '"]').forEach(function (c) {
      c.classList.toggle('is-active', chipState[key]);
      c.setAttribute('aria-pressed', chipState[key] ? 'true' : 'false');
    });
    applyChips();
  });
  document.addEventListener('click', function (e) {
    var counter = e.target.closest('[data-compare-counter]');
    if (counter) {
      var open = document.querySelector('[data-compare-open]');
      if (open && !open.disabled) open.click();
    }
  });

  /* ---------- recently viewed strip ---------- */
  var recentWrap = document.querySelector('[data-recently-viewed]');
  if (recentWrap) {
    var recent = [];
    try { recent = JSON.parse(localStorage.getItem('recently-viewed') || '[]'); } catch (e) {}
    var currentHandles = Array.from(document.querySelectorAll('[data-b2b-card]')).map(function (c) {
      return c.getAttribute('data-product-handle');
    });
    recent = recent.filter(function (r) { return currentHandles.indexOf(r.handle) === -1; }).slice(0, 8);
    if (recent.length) {
      var list = recentWrap.querySelector('[data-recently-viewed-list]');
      var esc2 = function (t) {
        return String(t).replace(/[&<>"']/g, function (ch) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
        });
      };
      list.innerHTML = recent.map(function (r) {
        if (String(r.url).indexOf('/') !== 0 || String(r.url).indexOf('//') === 0) return '';
        return '<li><article class="b2b-card b2b-card--grid"><div class="b2b-card__body">' +
          (r.brand ? '<p class="b2b-card__brand">' + esc2(r.brand) + '</p>' : '') +
          '<h3 class="b2b-card__title"><a class="b2b-card__title-link" href="' + esc2(r.url) + '">' + esc2(r.title) + '</a></h3>' +
          '<div class="b2b-card__price-row"><span class="b2b-card__price">' + esc2(r.price || '') + '</span></div>' +
          '</div></article></li>';
      }).join('');
      recentWrap.hidden = false;
    }
  }

  /* ---------- filter rail extras ---------- */
  /* collapse state remembered per facet group */
  document.querySelectorAll('#main-collection-filters details.facets__disclosure-vertical[id], #main-collection-filters details.facets__disclosure[id]').forEach(function (d) {
    var key = 'facet-open-' + d.id.replace(/[^a-zA-Z0-9_-]/g, '');
    try {
      var saved = localStorage.getItem(key);
      if (saved === '0') d.removeAttribute('open');
      if (saved === '1') d.setAttribute('open', '');
    } catch (e) {}
    d.addEventListener('toggle', function () {
      try { localStorage.setItem(key, d.open ? '1' : '0'); } catch (e) {}
    });
  });

  function enhanceFacets() {
    /* search box inside groups with >10 options (e.g. Brand) */
    document.querySelectorAll('#main-collection-filters details').forEach(function (group) {
      var lists = group.querySelectorAll('li');
      if (lists.length > 10 && !group.querySelector('[data-facet-search]')) {
        var box = document.createElement('div');
        box.className = 'facets__search';
        box.innerHTML = '<input type="search" data-facet-search placeholder="' + ((window.b2bStrings || {}).searchOptions || 'Search') + '" aria-label="Search options">';
        var content = group.querySelector('.facets__display, fieldset, ul');
        if (content && content.parentElement) content.parentElement.insertBefore(box, content);
        box.querySelector('input').addEventListener('input', function () {
          var q = this.value.toLowerCase();
          lists.forEach(function (li) {
            li.style.display = li.textContent.toLowerCase().indexOf(q) === -1 ? 'none' : '';
          });
        });
      }
    });

    /* dual-handle slider bound to Dawn's min/max price inputs */
    document.querySelectorAll('#main-collection-filters price-range').forEach(function (range) {
      if (range.querySelector('.plp-price-slider')) return;
      var inputs = range.querySelectorAll('input.field__input');
      if (inputs.length !== 2) return;
      var maxCap = parseFloat(inputs[1].getAttribute('data-max')) || parseFloat(inputs[1].getAttribute('max')) || 100;
      var slider = document.createElement('div');
      slider.className = 'plp-price-slider';
      slider.innerHTML =
        '<span class="plp-price-slider__track"></span><span class="plp-price-slider__fill"></span>' +
        '<span class="plp-price-slider__label" data-lo-label></span><span class="plp-price-slider__label" data-hi-label></span>' +
        '<input type="range" min="0" max="' + maxCap + '" step="1" value="' + (parseFloat(inputs[0].value) || 0) + '" aria-label="Minimum price">' +
        '<input type="range" min="0" max="' + maxCap + '" step="1" value="' + (parseFloat(inputs[1].value) || maxCap) + '" aria-label="Maximum price">';
      range.insertBefore(slider, range.firstChild);
      var handles = slider.querySelectorAll('input[type=range]');
      var fill = slider.querySelector('.plp-price-slider__fill');
      var loLabel = slider.querySelector('[data-lo-label]');
      var hiLabel = slider.querySelector('[data-hi-label]');
      function paint() {
        var lo = Math.min(parseFloat(handles[0].value), parseFloat(handles[1].value));
        var hi = Math.max(parseFloat(handles[0].value), parseFloat(handles[1].value));
        fill.style.left = (lo / maxCap) * 100 + '%';
        fill.style.width = ((hi - lo) / maxCap) * 100 + '%';
        if (loLabel) { loLabel.style.left = (lo / maxCap) * 100 + '%'; loLabel.textContent = '$' + Math.round(lo); }
        if (hiLabel) { hiLabel.style.left = (hi / maxCap) * 100 + '%'; hiLabel.textContent = '$' + Math.round(hi); }
      }
      var sliderTimer;
      handles.forEach(function (h) {
        h.addEventListener('input', function () {
          paint();
          clearTimeout(sliderTimer);
          sliderTimer = setTimeout(function () {
            h.dispatchEvent(new Event('change'));
          }, 300);
        });
        h.addEventListener('change', function () {
          var lo = Math.min(parseFloat(handles[0].value), parseFloat(handles[1].value));
          var hi = Math.max(parseFloat(handles[0].value), parseFloat(handles[1].value));
          inputs[0].value = lo > 0 ? lo : '';
          inputs[1].value = hi < maxCap ? hi : '';
          inputs[1].dispatchEvent(new Event('input', { bubbles: true }));
          inputs[1].dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      paint();
    });
  }
  var facetRail = document.getElementById('main-collection-filters');
  if (facetRail) {
    enhanceFacets();
    new MutationObserver(function () { enhanceFacets(); })
      .observe(facetRail, { childList: true, subtree: true });
  }

  /* ---------- load more (appends the next page's grid items) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    e.preventDefault();
    if (btn.hasAttribute('data-busy')) return;
    btn.setAttribute('data-busy', '');
    var old = btn.textContent;
    btn.textContent = (window.b2bStrings || {}).adding || '…';
    fetch(btn.href)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = document.getElementById('product-grid');
        var incoming = doc.getElementById('product-grid');
        if (grid && incoming) {
          incoming.querySelectorAll(':scope > li').forEach(function (li) { grid.appendChild(li); });
        }
        var countEl = document.getElementById('ProductCountDesktop');
        if (countEl && grid) {
          var visibleCount = grid.querySelectorAll(':scope > li [data-b2b-card]').length;
          countEl.textContent = countEl.textContent.replace(/\d+(?=\s*of)/, visibleCount);
        }
        var nextBtn = doc.querySelector('[data-load-more]');
        if (nextBtn) { btn.href = nextBtn.href; btn.textContent = old; btn.removeAttribute('data-busy'); }
        else { btn.closest('.plp-load-more').remove(); }
      })
      .catch(function () { btn.textContent = old; btn.removeAttribute('data-busy'); });
  });

  /* ---------- sub-category tile rail arrows ---------- */
  document.querySelectorAll('[data-tile-rail]').forEach(function (rail) {
    var track = rail.querySelector('[data-tiles-track]');
    var prev = rail.querySelector('[data-tiles-prev]');
    var next = rail.querySelector('[data-tiles-next]');
    if (!track || !prev || !next) return;
    function updateArrows() {
      var overflow = track.scrollWidth > track.clientWidth + 4;
      prev.hidden = !overflow || track.scrollLeft <= 4;
      next.hidden = !overflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
    var arrowsRaf = null;
    function queueUpdateArrows() {
      if (arrowsRaf) return;
      arrowsRaf = requestAnimationFrame(function () { arrowsRaf = null; updateArrows(); });
    }
    track.addEventListener('scroll', queueUpdateArrows, { passive: true });
    window.addEventListener('resize', queueUpdateArrows, { passive: true });
    updateArrows();
  });

  /* ---------- facet "See more" after 8 options ---------- */
  var SEE_MORE_LIMIT = 8;
  function applySeeMore(scope) {
    (scope || document).querySelectorAll('details.facets__disclosure-vertical .facets__list, details.facets__disclosure .facets__list').forEach(function (list) {
      if (list.hasAttribute('data-see-more-done')) return;
      var items = list.querySelectorAll(':scope > li');
      if (items.length <= SEE_MORE_LIMIT) return;
      list.setAttribute('data-see-more-done', '');
      for (var i = SEE_MORE_LIMIT; i < items.length; i++) items[i].classList.add('facet-over-limit');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'facet-see-more';
      var strings = window.b2bStrings || {};
      var moreLabel = (strings.see_more || 'See more ({n})').replace('{n}', items.length - SEE_MORE_LIMIT);
      btn.textContent = moreLabel;
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var expanded = list.classList.toggle('is-see-more-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.textContent = expanded ? (strings.see_less || 'See less') : moreLabel;
      });
      list.parentNode.insertBefore(btn, list.nextSibling);
    });
  }
  applySeeMore();
  var facetsWrapper = document.getElementById('main-collection-filters');
  if (facetsWrapper) {
    new MutationObserver(function () { applySeeMore(facetsWrapper); })
      .observe(facetsWrapper, { childList: true, subtree: true });
  }

  /* ---------- mobile sticky chip bar (appears on scroll) ---------- */
  var mobileBar = document.querySelector('[data-mobile-chip-bar]');
  if (mobileBar && window.matchMedia('(max-width: 749px)').matches) {
    var barTicking = false;
    window.addEventListener('scroll', function () {
      if (barTicking) return;
      barTicking = true;
      requestAnimationFrame(function () {
        mobileBar.classList.toggle('is-visible', window.scrollY > 420);
        barTicking = false;
      });
    }, { passive: true });
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-mobile-facets-open]');
    if (!open) return;
    /* the mobile facets drawer (filters + sort) opens via its summary */
    var summary = document.querySelector('.mobile-facets__open-wrapper, .mobile-facets__open');
    if (summary) summary.click();
  });

  /* ---------- Previously-purchased badge (from checkout starts) ---------- */
  try {
    var ordered = JSON.parse(localStorage.getItem('b2b-ordered') || '[]');
    if (ordered.length) {
      document.querySelectorAll('[data-prev-purchased]').forEach(function (badge) {
        var card = badge.closest('[data-b2b-card]');
        if (card && ordered.indexOf(card.getAttribute('data-product-handle')) !== -1) {
          badge.hidden = false;
        }
      });
    }
  } catch (e) {}
  /* checkout click promotes the cart's handles to 'ordered' */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.cart__checkout-button, [name="checkout"]')) return;
    try {
      var ch = JSON.parse(localStorage.getItem('b2b-cart-handles') || '[]');
      var ord = JSON.parse(localStorage.getItem('b2b-ordered') || '[]');
      ch.forEach(function (h) { if (ord.indexOf(h) === -1) ord.push(h); });
      localStorage.setItem('b2b-ordered', JSON.stringify(ord.slice(-120)));
      localStorage.removeItem('b2b-cart-handles');
    } catch (err) {}
  }, true);

  /* ---------- filter group order from the section setting ---------- */
  function orderFacets() {
    var orderAttr = document.querySelector('[data-facet-order]');
    if (!orderAttr) return;
    var wanted = orderAttr.getAttribute('data-facet-order').split(',').map(function (t) { return t.trim().toLowerCase(); });
    var rail = document.getElementById('main-collection-filters');
    var sheet = document.querySelector('#FacetFiltersFormMobile .mobile-facets__main');
    if (rail) orderGroups(rail, 'details.facets__disclosure-vertical, details.facets__disclosure', wanted);
    /* the mobile sheet gets the same merchant order, with Sort by as the first row (big-store sheet) */
    if (sheet) {
      orderGroups(sheet, 'details.mobile-facets__details', wanted);
      var sortRow = sheet.querySelector('.mobile-facets__sort');
      var sortGroup = sortRow && sortRow.closest('.mobile-facets__details');
      var firstGroup = sheet.querySelector('details.mobile-facets__details');
      if (sortGroup && firstGroup && firstGroup !== sortGroup) firstGroup.parentElement.insertBefore(sortGroup, firstGroup);
    }
  }
  function placeGroup(parent, group) {
    /* the mobile sheet ends with its sticky Remove all / Apply footer - groups go above it */
    var footer = parent.querySelector(':scope > .mobile-facets__footer');
    if (footer) parent.insertBefore(group, footer); else parent.appendChild(group);
  }
  function orderGroups(rail, selector, wanted) {
    /* the Category nav is pinned above the filter groups (big-store rail) - it never takes part in the ordering */
    var groups = Array.from(rail.querySelectorAll(selector)).filter(function (g) { return !g.classList.contains('facets__category-nav'); });
    if (!groups.length) return;
    var parent = groups[0].parentElement;
    wanted.forEach(function (name) {
      var match = groups.find(function (g) {
        var sum = g.querySelector('summary');
        return sum && sum.textContent.trim().toLowerCase().indexOf(name) === 0;
      });
      if (match) placeGroup(parent, match);
    });
    groups.forEach(function (g) {
      var sum = g.querySelector('summary');
      var label = sum ? sum.textContent.trim().toLowerCase() : '';
      var listed = wanted.some(function (n) { return label.indexOf(n) === 0; });
      if (!listed) placeGroup(parent, g);
    });
    /* Brand expanded by default unless the shopper collapsed it - desktop rail only: in the
       mobile sheet each group is a slide-in panel, and a pre-opened <details> made the first
       tap close it while the slide-in still fired (blank panel) */
    if (rail.classList.contains('mobile-facets__main')) return;
    var brand = groups.find(function (g) {
      var sum = g.querySelector('summary');
      return sum && sum.textContent.trim().toLowerCase().indexOf('brand') === 0;
    });
    if (brand) {
      var key = 'facet-open-' + brand.id.replace(/[^a-zA-Z0-9_-]/g, '');
      try { if (localStorage.getItem(key) === null) brand.setAttribute('open', ''); } catch (e) {}
    }
  }
  orderFacets();

  /* mobile sort select mirrors the desktop custom labels */
  function relabelMobileSort() {
    var desk = document.querySelector('[data-b2b-select][data-native="#SortBy"]');
    if (!desk) return;
    var labels = {};
    desk.querySelectorAll('.b2b-select__option').forEach(function (o) {
      labels[o.getAttribute('data-value')] = o.textContent.trim();
    });
    document.querySelectorAll('mobile-facets select[name="sort_by"] option, .mobile-facets__sort option').forEach(function (opt) {
      if (labels[opt.value]) opt.textContent = labels[opt.value];
    });
  }
  relabelMobileSort();
})();

/* ================= Quick view ================= */
(function () {
  'use strict';

  var cache = {};
  var modal = null;

  function sectionUrl(productUrl) {
    return productUrl.split('?')[0] + '?section_id=quick-view';
  }

  function fetchPanel(productUrl) {
    var url = sectionUrl(productUrl);
    if (!cache[url]) {
      cache[url] = fetch(url).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }).catch(function (err) {
        delete cache[url];
        throw err;
      });
    }
    return cache[url];
  }

  function ensureModal() {
    if (modal) return modal;
    var strings = window.b2bStrings || {};
    modal = document.createElement('div');
    modal.className = 'plp-compare-modal qv-modal';
    modal.setAttribute('data-qv-modal', '');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', strings.quickView || 'Quick view');
    modal.hidden = true;
    modal.innerHTML =
      '<div class="qv-modal__frame">' +
      '<button type="button" class="qv-modal__nav qv-modal__nav--prev" data-qv-nav="-1" aria-label="' + (strings.prevProduct || 'Previous product') + '" hidden>&lsaquo;</button>' +
      '<div class="plp-compare-modal__panel qv-modal__panel">' +
      '<div data-qv-host></div>' +
      '</div>' +
      '<button type="button" class="qv-modal__close" data-qv-close aria-label="' + (strings.close || 'Close') + '">&times;</button>' +
      '<button type="button" class="qv-modal__nav qv-modal__nav--next" data-qv-nav="1" aria-label="' + (strings.nextProduct || 'Next product') + '" hidden>&rsaquo;</button>' +
      '</div>';
    document.body.appendChild(modal);
    return modal;
  }

  var QV_SKELETON =
    '<div class="qv qv--skeleton" aria-hidden="true">' +
    '<div class="qv__media"><div class="qv-skel qv-skel--img"></div></div>' +
    '<div class="qv__info">' +
    '<div class="qv-skel qv-skel--line" style="width:30%"></div>' +
    '<div class="qv-skel qv-skel--line" style="width:85%;height:2rem"></div>' +
    '<div class="qv-skel qv-skel--line" style="width:60%"></div>' +
    '<div class="qv-skel qv-skel--line" style="width:40%;height:1.8rem"></div>' +
    '<div class="qv-skel qv-skel--block"></div>' +
    '<div class="qv-skel qv-skel--line" style="width:100%;height:4.8rem"></div>' +
    '<div class="qv-skel qv-skel--line" style="width:60%;height:4rem"></div>' +
    '</div></div>';

  /* prev/next product across the current page's quick-view triggers. When
     opened from inside a carousel, scope navigation to that carousel's own
     slides only (not every trigger on the page) - falls back to the whole
     page's triggers for PLP grids, which have no carousel ancestor. */
  function qvTriggers(trigger) {
    var scope = (trigger && trigger.closest('[data-carousel]')) || document;
    return Array.prototype.slice.call(scope.querySelectorAll('[data-quick-view]'));
  }

  function updateNav(m, trigger) {
    var list = qvTriggers(trigger);
    var i = list.indexOf(trigger);
    var prev = m.querySelector('[data-qv-nav="-1"]');
    var next = m.querySelector('[data-qv-nav="1"]');
    if (prev) prev.hidden = i <= 0;
    if (next) next.hidden = i === -1 || i >= list.length - 1;
    m._qvIndex = i;
  }

  function closeQv() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    if (modal._returnFocus) { modal._returnFocus.focus(); modal._returnFocus = null; }
  }

  function updateThumbArrows(m) {
    var strip = m.querySelector('[data-qv-thumbs]');
    if (!strip) return;
    var prev = m.querySelector('[data-qv-thumbs-prev]');
    var next = m.querySelector('[data-qv-thumbs-next]');
    var overflow = strip.scrollWidth > strip.clientWidth + 4;
    if (prev) prev.hidden = !overflow || strip.scrollLeft <= 4;
    if (next) next.hidden = !overflow || strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 4;
  }

  function openQv(trigger, productUrl) {
    var m = ensureModal();
    var host = m.querySelector('[data-qv-host]');
    host.innerHTML = QV_SKELETON;
    m.hidden = false;
    if (!m._returnFocus) m._returnFocus = trigger; /* keep origin across prev/next */
    m._qvTrigger = trigger;
    updateNav(m, trigger);
    var closeBtn = m.querySelector('[data-qv-close]');
    if (closeBtn) closeBtn.focus();
    if (window.trapModalFocus) window.trapModalFocus(m);
    fetchPanel(productUrl)
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-qv-content]');
        host.innerHTML = '';
        if (content) host.appendChild(content);
        updateThumbArrows(m);
        var strip = m.querySelector('[data-qv-thumbs]');
        if (strip) strip.addEventListener('scroll', function () { updateThumbArrows(m); }, { passive: true });
        if (window.B2BLists) {
          host.querySelectorAll('[data-add-to-list]').forEach(function (b) {
            b.classList.toggle('is-saved', window.B2BLists.isSaved(b.getAttribute('data-variant-id')));
          });
        }
        /* delivery suffix / get-it-by re-render for the injected content */
        if (window.DeliveryZip) window.DeliveryZip.refresh();
      })
      .catch(function () { closeQv(); });
    /* analytics hook */
    try {
      document.dispatchEvent(new CustomEvent('b2b:quick-view', { detail: { url: productUrl } }));
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('custom_quick_view_opened', { productUrl: productUrl });
      }
    } catch (e) {}
  }

  /* prefetch on hover */
  document.addEventListener('mouseover', function (e) {
    var qv = e.target.closest('[data-quick-view]');
    if (qv) fetchPanel(qv.getAttribute('data-product-url')).catch(function () {});
  });

  document.addEventListener('click', function (e) {
    var qv = e.target.closest('[data-quick-view]');
    if (qv) {
      e.preventDefault();
      e.stopPropagation();
      openQv(qv, qv.getAttribute('data-product-url'));
      return;
    }
    if (modal && !modal.hidden) {
      if (e.target.closest('[data-qv-close]') || e.target === modal || e.target.classList.contains('qv-modal__frame')) { closeQv(); return; }
      var nav = e.target.closest('[data-qv-nav]');
      if (nav) {
        var list = qvTriggers(modal._qvTrigger);
        var target = list[(modal._qvIndex || 0) + parseInt(nav.getAttribute('data-qv-nav'), 10)];
        if (target) openQv(target, target.getAttribute('data-product-url'));
        return;
      }
      var tPrev = e.target.closest('[data-qv-thumbs-prev]');
      var tNext = e.target.closest('[data-qv-thumbs-next]');
      if (tPrev || tNext) {
        var strip = modal.querySelector('[data-qv-thumbs]');
        if (strip) strip.scrollBy({ left: tPrev ? -160 : 160, behavior: 'smooth' });
        return;
      }
      var preset = e.target.closest('[data-qv-preset]');
      if (preset) {
        var qtyInput = modal.querySelector('.b2b-card__qty-input');
        if (qtyInput) qtyInput.value = preset.getAttribute('data-qty');
        modal.querySelectorAll('[data-qv-preset]').forEach(function (p) {
          p.classList.toggle('is-active', p === preset);
        });
        return;
      }
      var thumb = e.target.closest('[data-qv-thumb]');
      if (thumb) {
        var main = modal.querySelector('#QvMainImage');
        if (main) {
          /* the original srcset would keep winning over a swapped src */
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = thumb.getAttribute('data-full');
        }
        modal.querySelectorAll('[data-qv-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
          if (t === thumb) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        return;
      }
      var variantBtn = e.target.closest('[data-qv-variant]');
      if (variantBtn) {
        var selLabel = modal.querySelector('[data-qv-selected-option]');
        if (selLabel) selLabel.textContent = variantBtn.textContent.trim();
        modal.querySelectorAll('[data-qv-variant]').forEach(function (v) {
          v.setAttribute('aria-pressed', v === variantBtn ? 'true' : 'false');
          v.classList.toggle('is-active', v === variantBtn);
        });
        var add = modal.querySelector('[data-card-add]');
        if (add) add.setAttribute('data-variant-id', variantBtn.getAttribute('data-variant-id'));
        var price = modal.querySelector('.qv__price-value');
        if (price && variantBtn.getAttribute('data-price')) price.textContent = variantBtn.getAttribute('data-price');
        var list = modal.querySelector('[data-add-to-list]');
        if (list) list.setAttribute('data-variant-id', variantBtn.getAttribute('data-variant-id'));
      }
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden) { e.stopPropagation(); closeQv(); }
  }, true);
})();
}
